/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */
export const SHOW_DSGVO_BANNER = 'SHOW_DSGVO_BANNER';
export const HIDE_DSGVO_BANNER = 'HIDE_DSGVO_BANNER';
